import { DateTime } from "luxon";
import { DbBusinessReview } from "../business/models";
import { DbVisit } from "../visit/models";
import { Timestamp } from "firebase/firestore/lite";

export interface DbBooking {
  id: string;
  user_id: string;
  business_id: string;
  expires_at?: FirestoreTimestamp;
  entity_id: string;
  service_id: string;
  service_time: string;
  service_duration: number;
  total_amount: number;
  booking_amount: number;
  min_advanced_amount: number;
  platform_fees: number;
  paid_amount: number;
  payments: DbBookingPayment[];
  invoice_info?: DbInvoiceInfo;
  review?: DbBusinessReview;
  booking_date: FirestoreTimestamp;
  created_at: FirestoreTimestamp;
  booking_status?: DbServiceBookingStatus; // created, cancelled, confirmed
  previous_booking_status?: DbServiceBookingStatus; // created, confirmed
  business_member_created_id?: string;
  max_cancellation_time?: FirestoreTimestamp | null;
  cancellation_allowed?: boolean;
  share_id: string;
  additional_note?: string;
  payment_membership_id?: string;
  visit_id?: string;
}

export interface DbBookingPayment {
  created_at: FirestoreTimestamp;
  payment_id?: string;
  payment_membership_id?: string;
  type: string;
  amount: number;
  reward_points?: number;
  business_payee_id?: string;
}

interface DbInvoiceInfo {
  gst_code?: string;
  gst_number?: string;
  hsn_code?: string;
}

interface FirestoreTimestamp {
  toJSDate(): unknown;
  toMillis(): unknown;
  _seconds?: number;
  seconds?: number;
  _nanoseconds?: number;
  nanoseconds?: number;
}

export interface FutureBooking {
  entity_id: string;
  entity_name: string;
  service_id: string;
  service_time: string;
  booking_date: DateTime;
  service_duration: number;
  amount: number;
  available: boolean;
}

export enum DbServiceBookingStatus {
  created = "created",
  confirmed = "confirmed",
  cancelled = "cancelled",
}

export interface UserVisitItem {
  visit: DbVisit;
  isWalkIn: boolean;
  servicesCount: number;
  advanceBookingId?: string;
  serviceId?: string;
  entityId?: string;
  bookingTime?: Timestamp;
  bookingStatus?: DbServiceBookingStatus;
  serviceDuration?: number;
}
